import { useCallback, useEffect, useState } from "react";
import {
  getClientes,
  getCategorias,
  getSucursales,
} from "../services/semaforoCatalogoService";

export const useSemaforoCatalogo = () => {
  const [clientes, setClientes] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [sucursales, setSucursales] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCatalogo = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [clientesData, categoriasData, sucursalesData] = await Promise.all([
        getClientes(),
        getCategorias(),
        getSucursales(),
      ]);

      setClientes(clientesData);
      setCategorias(categoriasData);
      setSucursales(sucursalesData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCatalogo();
  }, [fetchCatalogo]);

  return {
    clientes,
    categorias,
    sucursales,
    loading,
    error,
    refresh: fetchCatalogo,
  };
};
